// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var Provider_Enum;
(function (Provider_Enum) {
    Provider_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    Provider_Enum["WEAVE"] = "WEAVE";
    Provider_Enum["MOCK"] = "MOCK";
    Provider_Enum["SENDGRID"] = "SENDGRID";
    Provider_Enum["MAILGUN"] = "MAILGUN";
    Provider_Enum["AWS"] = "AWS";
})(Provider_Enum || (Provider_Enum = {}));
export var Provider_Enum_index;
(function (Provider_Enum_index) {
    Provider_Enum_index[Provider_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    Provider_Enum_index[Provider_Enum_index["WEAVE"] = 1] = "WEAVE";
    Provider_Enum_index[Provider_Enum_index["MOCK"] = 2] = "MOCK";
    Provider_Enum_index[Provider_Enum_index["SENDGRID"] = 3] = "SENDGRID";
    Provider_Enum_index[Provider_Enum_index["MAILGUN"] = 4] = "MAILGUN";
    Provider_Enum_index[Provider_Enum_index["AWS"] = 5] = "AWS";
})(Provider_Enum_index || (Provider_Enum_index = {}));
export var RelatedType_Enum;
(function (RelatedType_Enum) {
    RelatedType_Enum["RELATED_TYPE_UNSPECIFIED"] = "RELATED_TYPE_UNSPECIFIED";
    RelatedType_Enum["RELATED_TYPE_APPOINTMENT"] = "RELATED_TYPE_APPOINTMENT";
    RelatedType_Enum["RELATED_TYPE_ORDER"] = "RELATED_TYPE_ORDER";
    RelatedType_Enum["RELATED_TYPE_RECALL"] = "RELATED_TYPE_RECALL";
    RelatedType_Enum["RELATED_TYPE_PERSON"] = "RELATED_TYPE_PERSON";
    RelatedType_Enum["RELATED_TYPE_REVIEW"] = "RELATED_TYPE_REVIEW";
    RelatedType_Enum["RELATED_TYPE_FORM"] = "RELATED_TYPE_FORM";
    RelatedType_Enum["RELATED_TYPE_SALESFORCE"] = "RELATED_TYPE_SALESFORCE";
    RelatedType_Enum["RELATED_TYPE_SCHEDULED_MESSAGE"] = "RELATED_TYPE_SCHEDULED_MESSAGE";
    RelatedType_Enum["RELATED_TYPE_BULK_MESSAGE"] = "RELATED_TYPE_BULK_MESSAGE";
    RelatedType_Enum["RELATED_TYPE_DESTINATION_LOCATION"] = "RELATED_TYPE_DESTINATION_LOCATION";
    RelatedType_Enum["RELATED_TYPE_FAX"] = "RELATED_TYPE_FAX";
    RelatedType_Enum["RELATED_TYPE_BULK_MESSAGE_V2"] = "RELATED_TYPE_BULK_MESSAGE_V2";
    RelatedType_Enum["RELATED_TYPE_BULK_CAMPAIGN"] = "RELATED_TYPE_BULK_CAMPAIGN";
    RelatedType_Enum["RELATED_TYPE_LOCATION_ID"] = "RELATED_TYPE_LOCATION_ID";
    RelatedType_Enum["RELATED_TYPE_TREATMENT_PLAN"] = "RELATED_TYPE_TREATMENT_PLAN";
})(RelatedType_Enum || (RelatedType_Enum = {}));
export var RelatedType_Enum_index;
(function (RelatedType_Enum_index) {
    RelatedType_Enum_index[RelatedType_Enum_index["RELATED_TYPE_UNSPECIFIED"] = 0] = "RELATED_TYPE_UNSPECIFIED";
    RelatedType_Enum_index[RelatedType_Enum_index["RELATED_TYPE_APPOINTMENT"] = 1] = "RELATED_TYPE_APPOINTMENT";
    RelatedType_Enum_index[RelatedType_Enum_index["RELATED_TYPE_ORDER"] = 2] = "RELATED_TYPE_ORDER";
    RelatedType_Enum_index[RelatedType_Enum_index["RELATED_TYPE_RECALL"] = 3] = "RELATED_TYPE_RECALL";
    RelatedType_Enum_index[RelatedType_Enum_index["RELATED_TYPE_PERSON"] = 4] = "RELATED_TYPE_PERSON";
    RelatedType_Enum_index[RelatedType_Enum_index["RELATED_TYPE_REVIEW"] = 5] = "RELATED_TYPE_REVIEW";
    RelatedType_Enum_index[RelatedType_Enum_index["RELATED_TYPE_FORM"] = 6] = "RELATED_TYPE_FORM";
    RelatedType_Enum_index[RelatedType_Enum_index["RELATED_TYPE_SALESFORCE"] = 7] = "RELATED_TYPE_SALESFORCE";
    RelatedType_Enum_index[RelatedType_Enum_index["RELATED_TYPE_SCHEDULED_MESSAGE"] = 8] = "RELATED_TYPE_SCHEDULED_MESSAGE";
    RelatedType_Enum_index[RelatedType_Enum_index["RELATED_TYPE_BULK_MESSAGE"] = 9] = "RELATED_TYPE_BULK_MESSAGE";
    RelatedType_Enum_index[RelatedType_Enum_index["RELATED_TYPE_DESTINATION_LOCATION"] = 10] = "RELATED_TYPE_DESTINATION_LOCATION";
    RelatedType_Enum_index[RelatedType_Enum_index["RELATED_TYPE_FAX"] = 11] = "RELATED_TYPE_FAX";
    RelatedType_Enum_index[RelatedType_Enum_index["RELATED_TYPE_BULK_MESSAGE_V2"] = 12] = "RELATED_TYPE_BULK_MESSAGE_V2";
    RelatedType_Enum_index[RelatedType_Enum_index["RELATED_TYPE_BULK_CAMPAIGN"] = 13] = "RELATED_TYPE_BULK_CAMPAIGN";
    RelatedType_Enum_index[RelatedType_Enum_index["RELATED_TYPE_LOCATION_ID"] = 14] = "RELATED_TYPE_LOCATION_ID";
    RelatedType_Enum_index[RelatedType_Enum_index["RELATED_TYPE_TREATMENT_PLAN"] = 15] = "RELATED_TYPE_TREATMENT_PLAN";
})(RelatedType_Enum_index || (RelatedType_Enum_index = {}));
export var BounceType_Enum;
(function (BounceType_Enum) {
    BounceType_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    BounceType_Enum["HARD_BOUNCE"] = "HARD_BOUNCE";
    BounceType_Enum["SOFT_BOUNCE"] = "SOFT_BOUNCE";
})(BounceType_Enum || (BounceType_Enum = {}));
export var BounceType_Enum_index;
(function (BounceType_Enum_index) {
    BounceType_Enum_index[BounceType_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    BounceType_Enum_index[BounceType_Enum_index["HARD_BOUNCE"] = 1] = "HARD_BOUNCE";
    BounceType_Enum_index[BounceType_Enum_index["SOFT_BOUNCE"] = 2] = "SOFT_BOUNCE";
})(BounceType_Enum_index || (BounceType_Enum_index = {}));
export var BounceClassification_Enum;
(function (BounceClassification_Enum) {
    BounceClassification_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    BounceClassification_Enum["INVALID_ADDRESS"] = "INVALID_ADDRESS";
    BounceClassification_Enum["TECHNICAL"] = "TECHNICAL";
    BounceClassification_Enum["CONTENT"] = "CONTENT";
    BounceClassification_Enum["REPUTATION"] = "REPUTATION";
    BounceClassification_Enum["FREQUENCY_VOLUME"] = "FREQUENCY_VOLUME";
    BounceClassification_Enum["MAILBOX_UNAVAILABLE"] = "MAILBOX_UNAVAILABLE";
    BounceClassification_Enum["UNCLASSIFIED"] = "UNCLASSIFIED";
})(BounceClassification_Enum || (BounceClassification_Enum = {}));
export var BounceClassification_Enum_index;
(function (BounceClassification_Enum_index) {
    BounceClassification_Enum_index[BounceClassification_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    BounceClassification_Enum_index[BounceClassification_Enum_index["INVALID_ADDRESS"] = 1] = "INVALID_ADDRESS";
    BounceClassification_Enum_index[BounceClassification_Enum_index["TECHNICAL"] = 2] = "TECHNICAL";
    BounceClassification_Enum_index[BounceClassification_Enum_index["CONTENT"] = 3] = "CONTENT";
    BounceClassification_Enum_index[BounceClassification_Enum_index["REPUTATION"] = 4] = "REPUTATION";
    BounceClassification_Enum_index[BounceClassification_Enum_index["FREQUENCY_VOLUME"] = 5] = "FREQUENCY_VOLUME";
    BounceClassification_Enum_index[BounceClassification_Enum_index["MAILBOX_UNAVAILABLE"] = 6] = "MAILBOX_UNAVAILABLE";
    BounceClassification_Enum_index[BounceClassification_Enum_index["UNCLASSIFIED"] = 7] = "UNCLASSIFIED";
})(BounceClassification_Enum_index || (BounceClassification_Enum_index = {}));
export var EventType_Enum;
(function (EventType_Enum) {
    EventType_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    EventType_Enum["DELIVERY"] = "DELIVERY";
    EventType_Enum["ENGAGEMENT"] = "ENGAGEMENT";
})(EventType_Enum || (EventType_Enum = {}));
export var EventType_Enum_index;
(function (EventType_Enum_index) {
    EventType_Enum_index[EventType_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    EventType_Enum_index[EventType_Enum_index["DELIVERY"] = 1] = "DELIVERY";
    EventType_Enum_index[EventType_Enum_index["ENGAGEMENT"] = 2] = "ENGAGEMENT";
})(EventType_Enum_index || (EventType_Enum_index = {}));
export var EventSubtype_Enum;
(function (EventSubtype_Enum) {
    EventSubtype_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    EventSubtype_Enum["SENT"] = "SENT";
    EventSubtype_Enum["ERRORED"] = "ERRORED";
    EventSubtype_Enum["PROCESSED"] = "PROCESSED";
    EventSubtype_Enum["DROPPED"] = "DROPPED";
    EventSubtype_Enum["DELIVERED"] = "DELIVERED";
    EventSubtype_Enum["DEFERRED"] = "DEFERRED";
    EventSubtype_Enum["BOUNCED"] = "BOUNCED";
    EventSubtype_Enum["OPENED"] = "OPENED";
    EventSubtype_Enum["CLICKED"] = "CLICKED";
    EventSubtype_Enum["SPAM_REPORTED"] = "SPAM_REPORTED";
    EventSubtype_Enum["UNSUBSCRIBED"] = "UNSUBSCRIBED";
    EventSubtype_Enum["GROUP_UNSUBSCRIBED"] = "GROUP_UNSUBSCRIBED";
    EventSubtype_Enum["GROUP_RESUBSCRIBED"] = "GROUP_RESUBSCRIBED";
    EventSubtype_Enum["NOT_SENT_INVALID"] = "NOT_SENT_INVALID";
    EventSubtype_Enum["NOT_SENT_UNSUBSCRIBED"] = "NOT_SENT_UNSUBSCRIBED";
    EventSubtype_Enum["NOT_SENT_MISSING_TO"] = "NOT_SENT_MISSING_TO";
})(EventSubtype_Enum || (EventSubtype_Enum = {}));
export var EventSubtype_Enum_index;
(function (EventSubtype_Enum_index) {
    EventSubtype_Enum_index[EventSubtype_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    EventSubtype_Enum_index[EventSubtype_Enum_index["SENT"] = 1] = "SENT";
    EventSubtype_Enum_index[EventSubtype_Enum_index["ERRORED"] = 2] = "ERRORED";
    EventSubtype_Enum_index[EventSubtype_Enum_index["PROCESSED"] = 3] = "PROCESSED";
    EventSubtype_Enum_index[EventSubtype_Enum_index["DROPPED"] = 4] = "DROPPED";
    EventSubtype_Enum_index[EventSubtype_Enum_index["DELIVERED"] = 5] = "DELIVERED";
    EventSubtype_Enum_index[EventSubtype_Enum_index["DEFERRED"] = 6] = "DEFERRED";
    EventSubtype_Enum_index[EventSubtype_Enum_index["BOUNCED"] = 7] = "BOUNCED";
    EventSubtype_Enum_index[EventSubtype_Enum_index["OPENED"] = 8] = "OPENED";
    EventSubtype_Enum_index[EventSubtype_Enum_index["CLICKED"] = 9] = "CLICKED";
    EventSubtype_Enum_index[EventSubtype_Enum_index["SPAM_REPORTED"] = 10] = "SPAM_REPORTED";
    EventSubtype_Enum_index[EventSubtype_Enum_index["UNSUBSCRIBED"] = 11] = "UNSUBSCRIBED";
    EventSubtype_Enum_index[EventSubtype_Enum_index["GROUP_UNSUBSCRIBED"] = 12] = "GROUP_UNSUBSCRIBED";
    EventSubtype_Enum_index[EventSubtype_Enum_index["GROUP_RESUBSCRIBED"] = 13] = "GROUP_RESUBSCRIBED";
    EventSubtype_Enum_index[EventSubtype_Enum_index["NOT_SENT_INVALID"] = 14] = "NOT_SENT_INVALID";
    EventSubtype_Enum_index[EventSubtype_Enum_index["NOT_SENT_UNSUBSCRIBED"] = 15] = "NOT_SENT_UNSUBSCRIBED";
    EventSubtype_Enum_index[EventSubtype_Enum_index["NOT_SENT_MISSING_TO"] = 16] = "NOT_SENT_MISSING_TO";
})(EventSubtype_Enum_index || (EventSubtype_Enum_index = {}));
